import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useContext, useState} from "react";
import {ReferralContext} from "../../../context/referral";
import dict from "../../../helper/dict";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import SelectInput from "../../system/select";
import {getReferralConfigs} from "../../../services/referral/referral_config";
import {updateReferral} from "../../../services/referral/referral";

export function ReferralForm() {


  const {
    referral,
    setReferral,
    setLastDataRefresh,
    setOpen,
    open,
  } = useContext(ReferralContext);

  const [referralConfigId, setReferralConfigId] = useState(referral?.referral_config_id ?? null)

  const handleOpen = () => setOpen(!open);

  const save = async () => {
    const data = {
      id: referral.id,
      referral_config_id: referralConfigId,
    };
    let result;

    result = await updateReferral(data);

    if (result.status === 200) {
      setReferral(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  if (referral) {
    return (
      <>
        <Dialog open={open} handler={handleOpen}
                animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>تنظیمات کد معرف</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

            <div className="grid grid-cols-1 gap-4">

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("user")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${referral.person_name}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("user_phone")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(referral.person_phone)}`}
                  </Typography>
                </div>
              </div>

              <SelectInput
                label={"تنظیمات کد معرف"}
                defaultValue={referral.referral_config_id}
                autoLoadService={getReferralConfigs}
                autoLoadRender={({title, value, referrer_share, referee_share, type}) => {
                  return `${title} - ${value} ${type === "purchase_cashback" ? '%' : 'ریال'} - ${referrer_share} ${type === "purchase_cashback" ? '%' : 'ریال'} - ${referee_share} ${type === "purchase_cashback" ? '%' : 'ریال'}`
                }}
                onChange={setReferralConfigId}
              />

            </div>

          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>ذخیره</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </>
    );
  }
}